import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import { BASE_URL } from '../../config/axios';
import * as XLSX from 'xlsx';
import { toast, ToastContainer } from 'react-toastify';
import { handleErrorToast, ProgressModal } from '../CustomFunctions';
import { Modal } from 'react-bootstrap';
import { Attachment, UpdatePencilWhite } from '../AllSvg';
import { AlertCircle, Download, Edit2Icon, FileText, Info, Upload, Users, X } from 'lucide-react';


// const BulkUpdateEmployee = ({ project, getData, designationList, toggleSubcompany }) => {

//     const [show, setShow] = useState(false);
//     const [employeeList, setEmployeeList] = useState([]);
//     const [fileName, setFileName] = useState("");
//     const [excelJson, setExcelJson] = useState(null); // State to store the converted JSON data
//     const [docErrors, setDocErrors] = useState({});
//     const [docInputState, setDocInputState] = useState({});


//     const bulkTableRef = useRef(null);

//     const s2ab = (s) => {
//         const buf = new ArrayBuffer(s.length);
//         const view = new Uint8Array(buf);
//         for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
//         return buf;
//     };
//     const handleDownload = () => {
//         const table = bulkTableRef.current;
//         const wb = XLSX.utils.table_to_book(table, { sheet: "Employee Details" });
//         const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

//         const blob = new Blob([s2ab(wbout)], {
//             type: "application/vnd.ms-excel",
//         });
//         const url = window.URL.createObjectURL(blob);
//         const a = document.createElement("a");
//         a.href = url;
//         a.download = "Employee Details Data Format.xls";
//         a.click();
//         window.URL.revokeObjectURL(url);
//     };


//     const getEmployeeData = async () => {
//         try {
//             const response = await axios.get(`${BASE_URL}/siteproject/employeefilterbyproject/${project}/${toggleSubcompany}/`);
//             setEmployeeList(response.data);
//         } catch (error) {
//             console.error("Error fetching employee data:", error);

//         }
//     }

//     useEffect(() => {
//         if (show) {
//             getEmployeeData();
//         }
//     }, [project, show, toggleSubcompany]);

//     const handleShow = () => {
//         setShow(true);
//     }

//     const handleClose = () => {
//         setShow(false);
//         setFileName("");
//         setExcelJson(null);
//         setDocErrors({});
//     }

//     const readExcel = (file) => {
//         const reader = new FileReader();
//         reader.onload = (e) => {
//             const data = new Uint8Array(e.target.result);
//             const workbook = XLSX.read(data, { type: "array" });

//             const sheetName = workbook.SheetNames[0]; // Use the first sheet
//             const worksheet = workbook.Sheets[sheetName];
//             const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null });

//             const headers = json[0];
//             // Filter out completely empty rows
//             const rows = json.slice(1).filter(row =>
//                 row.some(cell => cell !== null && cell !== "" && cell !== undefined)
//             );


//             // Function to convert Excel serial number to a date
//             const convertToYYYYMMDD = (input) => {
//                 try {
//                     let date;

//                     // Handle Excel serial dates
//                     if (typeof input === "number") {
//                         const excelEpoch = new Date(1900, 0, 1); // Excel epoch starts on Jan 1, 1900
//                         const daysOffset = input - 1; // Subtract 1 because of leap year bug
//                         date = new Date(excelEpoch.getTime() + daysOffset * 86400000);
//                     } else if (/^\d{4}\.\d{2}\.\d{2}$/.test(input)) {
//                         // Format: YYYY.MM.DD
//                         const [year, month, day] = input.split('.');
//                         date = new Date(`${year}-${month}-${day}`);
//                     } else if (/^\d{2}\.\d{2}\.\d{4}$/.test(input)) {
//                         // Format: DD.MM.YYYY
//                         const [day, month, year] = input.split('.');
//                         date = new Date(`${year}-${month}-${day}`);
//                     } else {
//                         // Default parsing for other formats
//                         date = new Date(input);
//                     }

//                     if (isNaN(date.getTime())) {
//                         throw new Error('Invalid date format');
//                     }

//                     // Format the date as YYYY-MM-DD
//                     const year = date.getFullYear();
//                     const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
//                     const day = String(date.getDate()).padStart(2, '0');

//                     return `${year}-${month}-${day}`;
//                 } catch (error) {
//                     return null; // Return null for invalid dates
//                 }
//             };

//             // Create a formatted JSON object based on headers and row values
//             const formattedJson = rows.map((row) => {
//                 const obj = {};
//                 headers.forEach((header, index) => {
//                     // Check if the column is one of the date fields and convert it if necessary
//                     // if (["dob", "joining_date", "intimation_date"].includes(header) && row[index] && typeof row[index] === "number") {
//                     if (["dob", "joining_date"].includes(header) && row[index] && typeof row[index] === "number") {
//                         obj[header] = convertToYYYYMMDD(row[index]); // Convert date
//                     } else {
//                         obj[header] = row[index] !== undefined ? row[index] : null;
//                     }
//                 });
//                 if (project) {
//                     obj["project"] = project;
//                 }

//                 return obj;
//             });

//             // Set the formatted JSON data to state
//             formattedJson.forEach((item, index) => {
//                 if (typeof item !== 'object' || item === null) {
//                     toast.error(`Row ${index + 2} in Excel is invalid.`);
//                     return;
//                 }

//                 const matchedDesignation = designationList.find((d) => {
//                     const isDesignationMatch = d.title?.toLowerCase() === item.designation_name?.toLowerCase();

//                     if (!isDesignationMatch) return false;

//                     // If division is missing, match sub_company_name
//                     if (!item.division || item.division.trim() === "") {
//                         return d.division_name?.toLowerCase() === item.sub_company_name?.toLowerCase();
//                     } else {
//                         return d.division?.toLowerCase() === item.division?.toLowerCase();
//                     }
//                 });

//                 if (matchedDesignation) {
//                     item.designation = matchedDesignation.id;
//                 } else {
//                     toast.error(`Designation not found for: ${item.designation_name || 'Missing'} in row ${index + 1}. Please add the designation first.`);
//                 }
//             });





//             setExcelJson(formattedJson);

//             setExcelJson(formattedJson);

//         };
//         reader.readAsArrayBuffer(file);
//     };




//     const handleFileChange = (e) => {
//         const file = e.target.files[0];
//         if (file) {
//             // Check for valid file type
//             const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
//             if (!validFileTypes.includes(file.type)) {
//                 setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
//                 setFileName("");
//                 return;
//             }

//             setFileName(file.name);
//             readExcel(file); // Convert the file to JSON
//         } else {
//             setFileName("");
//         }
//     };

//     const handleUpload = async () => {

//         if (excelJson) {

//             const loadingToastId = toast.loading("Uploading: Please wait...");
//             try {
//                 const res = await axios.put(`${BASE_URL}/siteproject/bulkemployeeupdatewithvalidations/`, excelJson);
//                 if (res.status === 200) {
//                     await getData();
//                     handleClose();
//                     toast.dismiss(loadingToastId);
//                     toast.success("Employees Updated successfully.");

//                 } else {
//                     toast.dismiss(loadingToastId);
//                     toast.error("Failed to add data!");
//                 }
//             } catch (err) {
//                 handleErrorToast(err);
//             } finally {
//                 toast.dismiss(loadingToastId);
//             }
//         } else {
//             setDocErrors({ document_file: "Please upload a valid Excel file." });
//         }
//     };

//     console.log(excelJson)




//     return (
//         <>

//             <button title="Upload" className="model-button   font-weight500   model-button-print" onClick={handleShow} style={{ margin: "2px" }}>
//                 Update
//             </button>

//             <Modal show={show} dialogClassName="ourcompany-model">
//                 {/* <Modal.Header closeButton>
//             <Modal.Title>Update Site Employee</Modal.Title>
//           </Modal.Header> */}
//                 <Modal.Body>
//                     <div className="flex-row align-center">

//                         <h1 className="font-size-text task-Tab-heading align-center  font-weight500 "><Modal.Title>Update Bulk Employee Data in format :</Modal.Title> </h1>


//                         <button onClick={handleDownload} className="model-button-download model-button font-weight500">
//                             <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="download" fill="#fff">
//                                 <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
//                                     <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
//                                 </g>
//                             </svg>
//                             {"  "} Format
//                         </button>

//                     </div>
//                     <div className="table-css-white-background" style={{ display: "none" }}>
//                         <table ref={bulkTableRef} className="nested-table-lightblue">
//                             <thead>
//                                 <tr className="custom-table-head-tr modal-padding-heading">
//                                     <th className="align-left">id</th>
//                                     <th className="align-left">emp_code</th>
//                                     {project !== "null" ? "" :
//                                         <th className="align-left">site_prcode</th>
//                                     }
//                                     <th className="align-center">name</th>
//                                     <th className="align-center">emp_role</th>
//                                     <th className="align-center">dob</th>
//                                     <th className="align-center">gender</th>
//                                     <th className="align-center">married_status</th>
//                                     <th className="align-center">qualification</th>
//                                     <th className="align-center">designation_name</th>
//                                     <th className="align-center">professional_type</th>
//                                     <th className="align-center">current_address</th>
//                                     <th className="align-center">mobile</th>
//                                     <th className="align-center">email</th>
//                                     <th className="align-center">joining_date</th>
//                                     <th className="align-center">employee_status</th>
//                                     <th className="align-center">emergency_person_name</th>
//                                     <th className="align-center">emergency_phone_number</th>
//                                     <th className="align-center">emergency_relation</th>
//                                     <th className="align-center">emergency_address</th>
//                                     <th className="align-center">division</th>
//                                     <th className="align-center">sub_company_name</th>
//                                     <th className="table-heading-text">actual_salary</th>
//                                     <th className="table-heading-text">boq_salary</th>
//                                     <th className="align-center">account_number</th>
//                                     <th className="align-center">ifsc_code</th>
//                                     <th className="align-center">account_holder_name</th>
//                                     <th className="align-center">bank_name</th>
//                                     <th className="align-center">branch_address</th>
//                                     <th className="align-center">uan</th>
//                                     <th className="align-center">esi</th>
//                                     <th className="align-center">aadhaar</th>
//                                     <th className="align-right">pan</th>
//                                 </tr>
//                             </thead>
//                             {employeeList?.map((employee, index) => (
//                                 <tr key={index}>
//                                     <th className="table-body">{employee.id}</th>
//                                     <th className="table-body">{employee.emp_code}</th>
//                                     {project !== "null" ? "" :
//                                         <th className="table-body">{employee.site_prcode}</th>
//                                     }
//                                     <th className="table-body">{employee.name}</th>
//                                     <th className="table-body">{employee.emp_role}</th>
//                                     <th className="table-body">{employee.dob}</th>
//                                     <th className="table-body">{employee.gender}</th>
//                                     <th className="table-body">{employee.married_status}</th>
//                                     <th className="table-body">{employee.qualification}</th>
//                                     <th className="table-body">{employee.designation_name}</th>
//                                     <th className="table-body">{employee.professional_type}</th>
//                                     <th className="table-body">{employee.current_address}</th>
//                                     <th className="table-body">{employee.mobile}</th>
//                                     <th className="table-body">{employee.email}</th>
//                                     <th className="table-body">{employee.joining_date}</th>
//                                     <th className="table-body">{employee.employee_status}</th>
//                                     <th className="table-body">{employee.emergency_person_name}</th>
//                                     <th className="table-body">{employee.emergency_phone_number}</th>
//                                     <th className="table-body">{employee.emergency_relation}</th>
//                                     <th className="table-body">{employee.emergency_address}</th>
//                                     <th className="table-body">{employee.division}</th>
//                                     <th className="table-body">{employee.sub_company_name}</th>
//                                     <th className="table-body">{employee.actual_salary}</th>
//                                     <th className="table-body">{employee.boq_salary}</th>
//                                     <th className="table-body">{employee.account_number}</th>
//                                     <th className="table-body">{employee.ifsc_code}</th>
//                                     <th className="table-body">{employee.account_holder_name}</th>
//                                     <th className="table-body">{employee.bank_name}</th>
//                                     <th className="table-body">{employee.branch_address}</th>
//                                     <th className="table-body">{employee.uan}</th>
//                                     <th className="table-body">{employee.esi}</th>
//                                     <th className="table-body">{employee.aadhaar}</th>
//                                     <th className="table-body">{employee.pan}</th>
//                                 </tr>
//                             ))}
//                         </table>
//                     </div>

//                     <div className="table-css-white-background scroll-container">
//                         <div className="table-container scrollbar" style={{ width: "100%" }}>

//                             <table className="nested-table-lightblue" style={{ margin: "0px" }}>
//                                 <thead className="table-heading">
//                                     <tr className="custom-table-head-tr modal-padding-heading">
//                                         <th className="table-heading-text">id</th>
//                                         <th className="table-heading-text">emp_code</th>
//                                         {project !== "null" ? "" :
//                                             <th className="table-heading-text">site_prcode</th>
//                                         }
//                                         <th className="table-heading-text">name</th>
//                                         <th className="table-heading-text">emp_role</th>
//                                         <th className="align-center">dob</th>

//                                         <th className="table-heading-text">gender</th>
//                                         <th className="table-heading-text">married_status</th>
//                                         <th className="table-heading-text">qualification</th>
//                                         <th className="table-heading-text">designation_name</th>
//                                         <th className="table-heading-text">professional_type</th>
//                                         <th className="table-heading-text">current_address</th>
//                                         <th className="table-heading-text">mobile</th>
//                                         <th className="table-heading-text">email</th>
//                                         <th className="table-heading-text width-5vw">joining_date</th>
//                                         <th className="table-heading-text">employee_status</th>
//                                         <th className="table-heading-text">emergency_person_name</th>
//                                         <th className="table-heading-text">emergency_phone_number</th>
//                                         <th className="table-heading-text">emergency_relation</th>
//                                         <th className="table-heading-text">emergency_address</th>
//                                         <th className="table-heading-text">division</th>
//                                         <th className="table-heading-text">sub_company_name</th>
//                                         <th className="table-heading-text">actual_salary</th>
//                                         <th className="table-heading-text">boq_salary</th>
//                                         <th className="table-heading-text">account_number</th>
//                                         <th className="table-heading-text">ifsc_code</th>
//                                         <th className="table-heading-text">account_holder_name</th>
//                                         <th className="table-heading-text">bank_name</th>
//                                         <th className="table-heading-text">branch_address</th>
//                                         <th className="table-heading-text">uan</th>
//                                         <th className="table-heading-text">esi</th>
//                                         <th className="table-heading-text">aadhaar</th>
//                                         <th className="table-heading-text">pan</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {excelJson?.map((employee, index) => (
//                                         <tr key={index}>
//                                             <th className="table-body">{employee.id}</th>
//                                             <th className="table-body">{employee.emp_code}</th>
//                                             {project !== "null" ? "" :
//                                                 <th className="table-body">{employee.site_prcode}</th>
//                                             }
//                                             <th className="table-body">{employee.name}</th>
//                                             <th className="table-body">{employee.emp_role}</th>
//                                             <th className="table-body">{employee.dob}</th>
//                                             <th className="table-body">{employee.gender}</th>
//                                             <th className="table-body">{employee.married_status}</th>
//                                             <th className="table-body">{employee.qualification}</th>
//                                             <th className="table-body">{employee.designation_name}</th>
//                                             <th className="table-body">{employee.professional_type}</th>
//                                             <th className="table-body">{employee.current_address}</th>
//                                             <th className="table-body">{employee.mobile}</th>
//                                             <th className="table-body">{employee.email}</th>
//                                             <th className="table-body">{employee.joining_date}</th>
//                                             <th className="table-body">{employee.employee_status}</th>
//                                             <th className="table-body">{employee.emergency_person_name}</th>
//                                             <th className="table-body">{employee.emergency_phone_number}</th>
//                                             <th className="table-body">{employee.emergency_relation}</th>
//                                             <th className="table-body">{employee.emergency_address}</th>
//                                             <th className="table-body">{employee.division}</th>
//                                             <th className="table-body">{employee.sub_company_name}</th>
//                                             <th className="table-body">{employee.actual_salary}</th>
//                                             <th className="table-body">{employee.boq_salary}</th>
//                                             {/* <th className="table-body">{employee.intimation_date}</th> */}
//                                             <th className="table-body">{employee.account_number}</th>
//                                             <th className="table-body">{employee.ifsc_code}</th>
//                                             <th className="table-body">{employee.account_holder_name}</th>
//                                             <th className="table-body">{employee.bank_name}</th>
//                                             <th className="table-body">{employee.branch_address}</th>
//                                             <th className="table-body">{employee.uan}</th>
//                                             <th className="table-body">{employee.esi}</th>
//                                             <th className="table-body">{employee.aadhaar}</th>
//                                             <th className="table-body">{employee.pan}</th>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>
//                         </div>

//                     </div>

//                     <h4>References:</h4>
//                     <div className="reference-container">
//                         <div className="reference-section">
//                             <p className="reference-title">General:</p>
//                             <ul className="arrow-list">
//                                 <li>Employee code should be unique.</li>
//                                 <li>Email should be valid.</li>
//                                 <li>Project should be existing.</li>
//                                 <li>In Project field only fill site project code.</li>
//                                 <li>Aadhar should have 12 digits with no spaces between the digits.</li>
//                                 <li>PAN should have 10 digits with no spaces between the digits.</li>
//                                 <li>Mobile numbers should have 10 digits, with no spaces between the digits, and should not start with "+91".</li>
//                                 <li>Add only one mobile  number</li>

//                             </ul>
//                         </div>
//                         <div className="reference-section">
//                             <p className="reference-title">In emp. role  use one of these:</p>
//                             <ul className="arrow-list">
//                                 <li>DataEntryOperator</li>
//                                 <li>AuthorityEngineer</li>
//                                 <li>Hr</li>
//                                 <li>Admin</li>
//                                 <li>BD</li>
//                                 <li>Account</li>
//                                 <li>SiteManagement</li>
//                             </ul>
//                         </div>
//                         <div className="reference-section">
//                             <p className="reference-title">In Professional Type use one of these:</p>
//                             <ul className="arrow-list">
//                                 <ul className="arrow-list">
//                                     <li>Key Professional</li>
//                                     <li>Sub Professional</li>
//                                     <li>Support Staff</li>
//                                 </ul>
//                             </ul>
//                         </div>
//                         <div className="reference-section">
//                             <p className="reference-title">In Employee Status use one of these:</p>
//                             <ul className="arrow-list">
//                                 <li>active</li>
//                                 <li>inactive</li>
//                             </ul>
//                         </div>
//                         <div className="reference-section">
//                             <p className="reference-title">In Marital Status use one of these:</p>
//                             <ul className="arrow-list">
//                                 <li>Single</li>
//                                 <li>Married</li>
//                                 <li>Divorced</li>
//                                 <li>Widowed</li>
//                                 <li>Separated</li>
//                             </ul>
//                         </div>
//                         <div className="date-section">
//                             <p className="date-text">All Dates should be in DD-MM-YYYY format</p>
//                         </div>
//                     </div>


//                     <div className="flex-column field-cont-div">
//                         <label htmlFor="document_file" className="form-labels announce-date font-weight500 font-size-heading">
//                             Upload File
//                         </label>
//                         <label
//                             htmlFor="document_file"
//                             className={`align-center form-inputss custom-file-upload ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
//                                 }`}
//                         >
//                             <div className={`align-center pdf-input  ${docErrors.document_file ? 'error' : ''}`}>
//                                 <Attachment />
//                             </div>
//                         </label>
//                         <input
//                             id="document_file"
//                             name="document_file"
//                             type="file"
//                             accept=".xlsx, .xls"
//                             onChange={handleFileChange}
//                             className="file-inputs align-center"
//                             style={{ display: "none", position: "relative" }}
//                         />
//                         {fileName && <p className="file-name align-center">{fileName}</p>}
//                         <br />
//                         {docErrors.document_file && <span className="file-name error-message font-size-text ">{docErrors.document_file}</span>}
//                     </div>

//                     <div className="button-models">
//                         <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
//                             Cancel
//                         </button>
//                         <button className="model-button-download model-button font-weight500" onClick={handleUpload}>
//                             <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
//                                 <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
//                                     <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
//                                 </g>
//                             </svg>
//                             {"  "} Update
//                         </button>
//                     </div>
//                     <ToastContainer position="top-center" autoClose={false} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

//                 </Modal.Body >
//             </Modal >
//         </>
//     );
// }

const BulkUpdateEmployee = ({ project, getData, designationList, toggleSubcompany }) => {

    const [show, setShow] = useState(false);
    const [employeeList, setEmployeeList] = useState([]);
    const [fileName, setFileName] = useState("");
    const [fileSize, setFileSize] = useState("");
    const [excelJson, setExcelJson] = useState(null);
    const [docErrors, setDocErrors] = useState({});
    const [docInputState, setDocInputState] = useState({});
    const [isDragging, setIsDragging] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);

    const bulkTableRef = useRef(null);
    const fileInputRef = useRef(null);

    const formatFileSize = (bytes) => {
        if (bytes < 1024) return `${bytes} B`;
        if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
        return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    };

    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    };

    const handleDownload = () => {
        const table = bulkTableRef.current;
        const wb = XLSX.utils.table_to_book(table, { sheet: "Employee Details" });
        const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

        const blob = new Blob([s2ab(wbout)], {
            type: "application/vnd.ms-excel",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Employee Details Data Format.xls";
        a.click();
        window.URL.revokeObjectURL(url);
    };

    const getEmployeeData = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/employeefilterbyproject/${project}/${toggleSubcompany}/`);
            setEmployeeList(response.data);
        } catch (error) {
            console.error("Error fetching employee data:", error);
        }
    };

    useEffect(() => {
        if (show) {
            getEmployeeData();
        }
    }, [project, show, toggleSubcompany]);

    const handleShow = () => setShow(true);

    const handleClose = () => {
        setShow(false);
        setFileName("");
        setFileSize("");
        setExcelJson(null);
        setDocErrors({});
        setDocInputState({});
    };

    const handleRemoveFile = () => {
        setFileName("");
        setFileSize("");
        setExcelJson(null);
        setDocErrors({});
        setDocInputState({});
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const readExcel = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null });

            const headers = json[0];
            const rows = json.slice(1).filter(row =>
                row.some(cell => cell !== null && cell !== "" && cell !== undefined)
            );

            const convertToYYYYMMDD = (input) => {
                try {
                    let date;
                    if (typeof input === "number") {
                        const excelEpoch = new Date(1900, 0, 1);
                        const daysOffset = input - 1;
                        date = new Date(excelEpoch.getTime() + daysOffset * 86400000);
                    } else if (/^\d{4}\.\d{2}\.\d{2}$/.test(input)) {
                        const [year, month, day] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else if (/^\d{2}\.\d{2}\.\d{4}$/.test(input)) {
                        const [day, month, year] = input.split('.');
                        date = new Date(`${year}-${month}-${day}`);
                    } else {
                        date = new Date(input);
                    }

                    if (isNaN(date.getTime())) {
                        throw new Error('Invalid date format');
                    }

                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    return `${year}-${month}-${day}`;
                } catch (error) {
                    return null;
                }
            };

            const formattedJson = rows.map((row) => {
                const obj = {};
                headers.forEach((header, index) => {
                    if (["dob", "joining_date"].includes(header) && row[index] && typeof row[index] === "number") {
                        obj[header] = convertToYYYYMMDD(row[index]);
                    } else {
                        obj[header] = row[index] !== undefined ? row[index] : null;
                    }
                });
                if (project) {
                    obj["project"] = project;
                }
                return obj;
            });

            formattedJson.forEach((item, index) => {
                if (typeof item !== 'object' || item === null) {
                    toast.error(`Row ${index + 2} in Excel is invalid.`);
                    return;
                }

                const matchedDesignation = designationList.find((d) => {
                    const isDesignationMatch = d.title?.toLowerCase() === item.designation_name?.toLowerCase();
                    if (!isDesignationMatch) return false;
                    if (!item.division || item.division.trim() === "") {
                        return d.division_name?.toLowerCase() === item.sub_company_name?.toLowerCase();
                    } else {
                        return d.division?.toLowerCase() === item.division?.toLowerCase();
                    }
                });

                if (matchedDesignation) {
                    item.designation = matchedDesignation.id;
                } else {
                    toast.error(`Designation not found for: ${item.designation_name || 'Missing'} in row ${index + 1}. Please add the designation first.`);
                }
            });

            setExcelJson(formattedJson);
        };
        reader.readAsArrayBuffer(file);
    };

    const processFile = (file) => {
        if (!file) return;
        const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
        if (!validFileTypes.includes(file.type)) {
            setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
            setFileName("");
            setFileSize("");
            return;
        }

        setFileName(file.name);
        setFileSize(formatFileSize(file.size));
        setDocErrors({});
        setDocInputState({ document_file: "green" });
        readExcel(file);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        processFile(file);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        const file = e.dataTransfer.files[0];
        processFile(file);
    };

    const handleUpload = async () => {
        if (excelJson) {
            setShowProgressModal(true);
            setUploadProgress(0);

            const loadingToastId = toast.loading("Uploading: Please wait...");

            let progress = 0;
            const interval = setInterval(() => {
                progress += 10;
                if (progress >= 100) {
                    progress = 100;
                    clearInterval(interval);
                }
                setUploadProgress(progress);
            }, 100);

            try {
                const res = await axios.put(`${BASE_URL}/siteproject/bulkemployeeupdatewithvalidations/`, excelJson);
                if (res.status === 200) {
                    await getData();
                    toast.dismiss(loadingToastId);
                    toast.success("Employees Updated successfully.");
                    handleClose();
                } else {
                    toast.dismiss(loadingToastId);
                    toast.error("Failed to add data!");
                }
            } catch (err) {
                clearInterval(interval);
                setUploadProgress(0);
                handleErrorToast(err);
            } finally {
                clearInterval(interval);
                setTimeout(() => {
                    setShowProgressModal(false);
                }, 1500);
                toast.dismiss(loadingToastId);
            }
        } else {
            setDocErrors({ document_file: "Please upload a valid Excel file." });
        }
    };

    return (
        <>
            <style>{`
                .ub-upload-zone {
                    border: 2px dashed #c7cdd6;
                    border-radius: 14px;
                    background: #fafbfd;
                    padding: 32px 20px;
                    text-align: center;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    position: relative;
                }
                .ub-upload-zone:hover {
                    border-color: #6366f1;
                    background: #f5f5ff;
                }
                .ub-upload-zone.dragging {
                    border-color: #6366f1;
                    background: #eef0ff;
                    transform: scale(1.01);
                }
                .ub-upload-zone.has-error {
                    border-color: #e11d48;
                    background: #fff1f2;
                }
                .ub-upload-icon-circle {
                    width: 56px;
                    height: 56px;
                    border-radius: 50%;
                    background: linear-gradient(135deg, #6366f1, #8b5cf6);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 auto 14px;
                    color: white;
                    box-shadow: 0 4px 14px rgba(99, 102, 241, 0.3);
                }
                .ub-upload-title {
                    font-size: 15px;
                    font-weight: 600;
                    color: #1f2937;
                    margin: 0 0 4px;
                }
                .ub-upload-subtitle {
                    font-size: 13px;
                    color: #6b7280;
                    margin: 0;
                }
                .ub-upload-browse {
                    color: #6366f1;
                    font-weight: 600;
                    text-decoration: underline;
                }
                .ub-file-card {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    background: #f0fdf4;
                    border: 1px solid #bbf7d0;
                    border-radius: 12px;
                    padding: 14px 16px;
                    margin-top: 12px;
                    animation: ub-fade-in 0.25s ease;
                }
                .ub-file-icon {
                    width: 40px;
                    height: 40px;
                    border-radius: 10px;
                    background: #16a34a;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    flex-shrink: 0;
                }
                .ub-file-info {
                    flex: 1;
                    min-width: 0;
                }
                .ub-file-name {
                    font-size: 14px;
                    font-weight: 600;
                    color: #1f2937;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .ub-file-size {
                    font-size: 12px;
                    color: #6b7280;
                }
                .ub-file-remove {
                    background: none;
                    border: none;
                    cursor: pointer;
                    color: #9ca3af;
                    padding: 6px;
                    border-radius: 8px;
                    display: flex;
                    transition: all 0.15s ease;
                    flex-shrink: 0;
                }
                .ub-file-remove:hover {
                    background: #fee2e2;
                    color: #dc2626;
                }
                @keyframes ub-fade-in {
                    from { opacity: 0; transform: translateY(-4px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .ub-preview-wrap {
                    border: 1px solid #e5e7eb;
                    border-radius: 14px;
                    overflow: hidden;
                    margin-top: 8px;
                }
                .ub-preview-scroll {
                    overflow-x: auto;
                    max-height: 340px;
                    overflow-y: auto;
                }
                .ub-preview-table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 13px;
                    white-space: nowrap;
                }
                .ub-preview-table thead th {
                    position: sticky;
                    top: 0;
                    background: #f8fafc;
                    color: #475569;
                    font-weight: 600;
                    text-align: left;
                    padding: 10px 14px;
                    border-bottom: 2px solid #e2e8f0;
                    z-index: 1;
                }
                .ub-preview-table tbody td {
                    padding: 9px 14px;
                    color: #334155;
                    border-bottom: 1px solid #f1f5f9;
                }
                .ub-preview-table tbody tr:nth-child(even) {
                    background: #fbfcfe;
                }
                .ub-preview-table tbody tr:hover {
                    background: #f0f4ff;
                }
                .ub-preview-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 10px 4px;
                }
                .ub-preview-badge {
                    background: #eef2ff;
                    color: #4338ca;
                    font-size: 12px;
                    font-weight: 600;
                    padding: 4px 10px;
                    border-radius: 999px;
                }
                .ub-download-row {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    background: #f8fafc;
                    border: 1px solid #e5e7eb;
                    border-radius: 12px;
                    padding: 14px 16px;
                    margin-bottom: 18px;
                    gap: 12px;
                }
                .ub-download-row p {
                    margin: 0;
                    font-size: 13.5px;
                    color: #475569;
                }
                .ub-ref-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
                    gap: 12px;
                    margin-top: 8px;
                }
                .ub-ref-card {
                    background: #f8fafc;
                    border: 1px solid #e5e7eb;
                    border-radius: 12px;
                    padding: 14px 16px;
                }
                .ub-ref-card h5 {
                    margin: 0 0 8px;
                    font-size: 13px;
                    font-weight: 700;
                    color: #4338ca;
                }
                .ub-ref-card ul {
                    margin: 0;
                    padding-left: 18px;
                    font-size: 12.5px;
                    color: #475569;
                    line-height: 1.7;
                }
            `}</style>

            <button title="Bulk Update" className="btn-animated" onClick={handleShow} style={{ margin: "2px" }}>
                <Edit2Icon size={16} style={{ marginRight: "6px" }} /> Bulk Update
            </button>

            {showProgressModal ? (
                <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Update" />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal model-width80vw" size="xl">
                    <Modal.Header className="modern-modal-header">
                        <div className="header-content">
                            <div style={{ color: "white" }}>
                                <Edit2Icon size={24} />
                            </div>
                            <div>
                                <Modal.Title>Update Bulk Employee Data</Modal.Title>
                                <p className="header-subtitle" style={{ color: "white" }}>Update multiple employees at once using the Excel format</p>
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <Modal.Body className="modern-modal-body">

                        <div className="ub-download-row">
                            <p><FileText size={14} style={{ marginRight: '6px', verticalAlign: 'middle' }} />
                                Download the current employee data as a template, edit the fields, then upload below.
                            </p>
                            <button onClick={handleDownload} className="btn-primaryy" type="button" style={{ flexShrink: 0 }}>
                                <Download size={16} />
                                <span>Format</span>
                            </button>
                        </div>

                        {/* Hidden table used only to build the downloadable XLS from current employee data */}
                        <div className="table-css-white-background" style={{ display: "none" }}>
                            <table ref={bulkTableRef} className="nested-table-lightblue">
                                <thead>
                                    <tr className="custom-table-head-tr modal-padding-heading">
                                        <th className="align-left">id</th>
                                        <th className="align-left">emp_code</th>
                                        {project !== "null" ? "" : <th className="align-left">site_prcode</th>}
                                        <th className="align-center">name</th>
                                        <th className="align-center">emp_role</th>
                                        <th className="align-center">dob</th>
                                        <th className="align-center">gender</th>
                                        <th className="align-center">married_status</th>
                                        <th className="align-center">qualification</th>
                                        <th className="align-center">designation_name</th>
                                        <th className="align-center">professional_type</th>
                                        <th className="align-center">current_address</th>
                                        <th className="align-center">mobile</th>
                                        <th className="align-center">email</th>
                                        <th className="align-center">joining_date</th>
                                        <th className="align-center">employee_status</th>
                                        <th className="align-center">emergency_person_name</th>
                                        <th className="align-center">emergency_phone_number</th>
                                        <th className="align-center">emergency_relation</th>
                                        <th className="align-center">emergency_address</th>
                                        <th className="align-center">division</th>
                                        <th className="align-center">sub_company_name</th>
                                        <th className="table-heading-text">actual_salary</th>
                                        <th className="table-heading-text">boq_salary</th>
                                        <th className="align-center">account_number</th>
                                        <th className="align-center">ifsc_code</th>
                                        <th className="align-center">account_holder_name</th>
                                        <th className="align-center">bank_name</th>
                                        <th className="align-center">branch_address</th>
                                        <th className="align-center">uan</th>
                                        <th className="align-center">esi</th>
                                        <th className="align-center">aadhaar</th>
                                        <th className="align-right">pan</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {employeeList?.map((employee, index) => (
                                        <tr key={index}>
                                            <th className="table-body">{employee.id}</th>
                                            <th className="table-body">{employee.emp_code}</th>
                                            {project !== "null" ? "" : <th className="table-body">{employee.site_prcode}</th>}
                                            <th className="table-body">{employee.name}</th>
                                            <th className="table-body">{employee.emp_role}</th>
                                            <th className="table-body">{employee.dob}</th>
                                            <th className="table-body">{employee.gender}</th>
                                            <th className="table-body">{employee.married_status}</th>
                                            <th className="table-body">{employee.qualification}</th>
                                            <th className="table-body">{employee.designation_name}</th>
                                            <th className="table-body">{employee.professional_type}</th>
                                            <th className="table-body">{employee.current_address}</th>
                                            <th className="table-body">{employee.mobile}</th>
                                            <th className="table-body">{employee.email}</th>
                                            <th className="table-body">{employee.joining_date}</th>
                                            <th className="table-body">{employee.employee_status}</th>
                                            <th className="table-body">{employee.emergency_person_name}</th>
                                            <th className="table-body">{employee.emergency_phone_number}</th>
                                            <th className="table-body">{employee.emergency_relation}</th>
                                            <th className="table-body">{employee.emergency_address}</th>
                                            <th className="table-body">{employee.division}</th>
                                            <th className="table-body">{employee.sub_company_name}</th>
                                            <th className="table-body">{employee.actual_salary}</th>
                                            <th className="table-body">{employee.boq_salary}</th>
                                            <th className="table-body">{employee.account_number}</th>
                                            <th className="table-body">{employee.ifsc_code}</th>
                                            <th className="table-body">{employee.account_holder_name}</th>
                                            <th className="table-body">{employee.bank_name}</th>
                                            <th className="table-body">{employee.branch_address}</th>
                                            <th className="table-body">{employee.uan}</th>
                                            <th className="table-body">{employee.esi}</th>
                                            <th className="table-body">{employee.aadhaar}</th>
                                            <th className="table-body">{employee.pan}</th>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="section-title">
                            <Upload size={18} />
                            <h4>Upload File</h4>
                        </div>

                        <div
                            className={`ub-upload-zone ${isDragging ? 'dragging' : ''} ${docErrors.document_file ? 'has-error' : ''}`}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                            onClick={() => fileInputRef.current?.click()}
                        >
                            <div className="ub-upload-icon-circle">
                                <Upload size={24} />
                            </div>
                            <p className="ub-upload-title">
                                Drag & drop your Excel file here
                            </p>
                            <p className="ub-upload-subtitle">
                                or <span className="ub-upload-browse">browse</span> to choose a file &nbsp;·&nbsp; .xlsx or .xls
                            </p>
                            <input
                                ref={fileInputRef}
                                id="document_file"
                                name="document_file"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileChange}
                                style={{ display: "none" }}
                            />
                        </div>

                        {docErrors.document_file && (
                            <div className="tab-error-message" style={{ marginTop: '10px' }}>
                                <AlertCircle size={14} />
                                <span>{docErrors.document_file}</span>
                            </div>
                        )}

                        {fileName && !docErrors.document_file && (
                            <div className="ub-file-card">
                                <div className="ub-file-icon">
                                    <FileText size={20} />
                                </div>
                                <div className="ub-file-info">
                                    <div className="ub-file-name">{fileName}</div>
                                    <div className="ub-file-size">{fileSize}{excelJson ? ` · ${excelJson.length} records found` : ''}</div>
                                </div>
                                <button type="button" className="ub-file-remove" onClick={handleRemoveFile} title="Remove file">
                                    <X size={18} />
                                </button>
                            </div>
                        )}

                        {excelJson && excelJson.length > 0 && (
                            <>
                                <div className="ub-preview-header">
                                    <div className="section-title" style={{ marginBottom: 0 }}>
                                        <Users size={18} />
                                        <h4 style={{ margin: 0 }}>Preview</h4>
                                    </div>
                                    <span className="ub-preview-badge">{excelJson.length} employees</span>
                                </div>

                                <div className="ub-preview-wrap">
                                    <div className="ub-preview-scroll table-box scroll-container-table">
                                        <table className="ub-preview-table">
                                            <thead className="table-heading">
                                                <tr>
                                                    <th>ID</th>
                                                    <th>Emp Code</th>
                                                    {project !== "null" ? null : <th>Site Code</th>}
                                                    <th>Name</th>
                                                    <th>Role</th>
                                                    <th>DOB</th>
                                                    <th>Gender</th>
                                                    <th>Marital Status</th>
                                                    <th>Qualification</th>
                                                    <th>Designation</th>
                                                    <th>Type</th>
                                                    <th>Address</th>
                                                    <th>Mobile</th>
                                                    <th>Email</th>
                                                    <th>Joining Date</th>
                                                    <th>Status</th>
                                                    <th>Emergency Name</th>
                                                    <th>Emergency Phone</th>
                                                    <th>Relation</th>
                                                    <th>Emergency Address</th>
                                                    <th>Division</th>
                                                    <th>Sub Company</th>
                                                    <th>Actual Salary</th>
                                                    <th>BOQ Salary</th>
                                                    <th>Account No.</th>
                                                    <th>IFSC</th>
                                                    <th>Account Holder</th>
                                                    <th>Bank</th>
                                                    <th>Branch</th>
                                                    <th>UAN</th>
                                                    <th>ESI</th>
                                                    <th>Aadhaar</th>
                                                    <th>PAN</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {excelJson.map((employee, index) => (
                                                    <tr key={index}>
                                                        <td>{employee.id}</td>
                                                        <td>{employee.emp_code}</td>
                                                        {project !== "null" ? null : <td>{employee.site_prcode}</td>}
                                                        <td>{employee.name}</td>
                                                        <td>{employee.emp_role}</td>
                                                        <td>{employee.dob}</td>
                                                        <td>{employee.gender}</td>
                                                        <td>{employee.married_status}</td>
                                                        <td>{employee.qualification}</td>
                                                        <td>{employee.designation_name}</td>
                                                        <td>{employee.professional_type}</td>
                                                        <td>{employee.current_address}</td>
                                                        <td>{employee.mobile}</td>
                                                        <td>{employee.email}</td>
                                                        <td>{employee.joining_date}</td>
                                                        <td>{employee.employee_status}</td>
                                                        <td>{employee.emergency_person_name}</td>
                                                        <td>{employee.emergency_phone_number}</td>
                                                        <td>{employee.emergency_relation}</td>
                                                        <td>{employee.emergency_address}</td>
                                                        <td>{employee.division}</td>
                                                        <td>{employee.sub_company_name}</td>
                                                        <td>{employee.actual_salary}</td>
                                                        <td>{employee.boq_salary}</td>
                                                        <td>{employee.account_number}</td>
                                                        <td>{employee.ifsc_code}</td>
                                                        <td>{employee.account_holder_name}</td>
                                                        <td>{employee.bank_name}</td>
                                                        <td>{employee.branch_address}</td>
                                                        <td>{employee.uan}</td>
                                                        <td>{employee.esi}</td>
                                                        <td>{employee.aadhaar}</td>
                                                        <td>{employee.pan}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </>
                        )}

                        <div className="section-title" style={{ marginTop: '20px' }}>
                            <Info size={18} />
                            <h4>References</h4>
                        </div>
                        <div className="ub-ref-grid">
                            <div className="ub-ref-card">
                                <h5>General</h5>
                                <ul>
                                    <li>Employee code should be unique.</li>
                                    <li>Email should be valid.</li>
                                    <li>Project should be existing.</li>
                                    <li>Fill only the site project code in the Project field.</li>
                                    <li>Aadhaar should have 12 digits, no spaces.</li>
                                    <li>PAN should have 10 digits, no spaces.</li>
                                    <li>Mobile numbers: 10 digits, no "+91".</li>
                                    <li>Add only one mobile number.</li>
                                </ul>
                            </div>
                            <div className="ub-ref-card">
                                <h5>Employee Role Options</h5>
                                <ul>
                                    <li>DataEntryOperator</li>
                                    <li>AuthorityEngineer</li>
                                    <li>Hr</li>
                                    <li>Admin</li>
                                    <li>BD</li>
                                    <li>Account</li>
                                    <li>SiteManagement</li>
                                </ul>
                            </div>
                            <div className="ub-ref-card">
                                <h5>Professional Type</h5>
                                <ul>
                                    <li>Key Professional</li>
                                    <li>Sub Professional</li>
                                    <li>Support Staff</li>
                                </ul>
                            </div>
                            <div className="ub-ref-card">
                                <h5>Employee Status</h5>
                                <ul>
                                    <li>active</li>
                                    <li>inactive</li>
                                </ul>
                            </div>
                            <div className="ub-ref-card">
                                <h5>Marital Status</h5>
                                <ul>
                                    <li>Single</li>
                                    <li>Married</li>
                                    <li>Divorced</li>
                                    <li>Widowed</li>
                                    <li>Separated</li>
                                </ul>
                            </div>
                            <div className="ub-ref-card">
                                <h5>Date Format</h5>
                                <ul>
                                    <li>All dates: DD-MM-YYYY</li>
                                </ul>
                            </div>
                        </div>

                        <div className="form-actions">
                            <button type="button" className="btn-secondaryy" onClick={handleClose}>
                                Cancel
                            </button>
                            <button type="button" className="btn-primaryy" onClick={handleUpload} disabled={!excelJson}>
                                <Upload size={18} />
                                <span>Update</span>
                            </button>
                        </div>

                        <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

export default BulkUpdateEmployee